// src/composables/useRoomPrice.js
import { computed } from 'vue'

export function useRoomPrice(reservationForm, rooms) {
  const isHighSeason = computed(() => {
    const startDate = new Date(reservationForm.value.start)
    const endDate = new Date(reservationForm.value.end)

    // Bulan Juni (index ke-5)
    return startDate.getMonth() === 5 || endDate.getMonth() === 5
  })

  const roomPrice = computed(() => {
    const selectedRoom = rooms.value.find(
      (room) => room.uuid === reservationForm.value.room_uuid
    )

    if (!selectedRoom) return 0

    const priceType = isHighSeason.value
      ? 'high_season_price'
      : 'low_season_price'

    return selectedRoom.room_category[priceType] || 0
  })

  return {
    isHighSeason,
    roomPrice
  }
}
